<template>
  <div id="screen-wrapper" class="pos-relative o-hidden w-100 h-100">
    <Preloader v-if="showPreloader" @complete="onPreloaderComplete" />
    <CursorLabel />
    <component v-if="$route.meta.header" :is="$route.meta.header"
      :theme="headerTheme"
      :logotype="$route.meta.logotype"
      :location="$route.meta.location"
      :showCart="$route.meta.header_show_cart"
      :showProfile="$route.meta.header_show_profile"
      :showNotifications="$route.meta.header_show_notifications"
    />
    <div class="flex flex-nowrap h-100 o-hidden" :class="{ 'flex-column': !$route.meta.sidebar }">
      <component
        v-if="$route.meta?.sidebar"
        :is="$route.meta.sidebar"
        :stateSidebar="store.core.state.isOpenSidebar"
        :widthHidden="$route.meta?.sidebar_width_hidden"
        :width="$route.meta?.sidebar_width"
        :theme="headerTheme"
        @closeSidebar="() => (store.core.state.isOpenSidebar = false)"
      >
        <template #header>
          <component v-if="$route.meta?.sidebar_header_component" :is="$route.meta.sidebar_header_component" :theme="headerTheme" />
        </template>
        <component
          v-if="$route.meta?.sidebar_navigation"
          :is="$route.meta.sidebar_navigation"
          :key="$route.meta.sidebar_navigation_items"
          :navigationItems="$route.meta.sidebar_navigation_items"
          v-model:stateSidebar="store.core.state.isOpenSidebar"
          :theme="headerTheme"
        />
        <template #footer>
          <component v-if="$route.meta?.sidebar_footer_component" :is="$route.meta.sidebar_footer_component" :theme="headerTheme" :stateSidebar="store.core.state.isOpenSidebar" />
        </template>
      </component>
    <div id="screen" class="w-100" :class="route.params.slug">
      <!-- <Cursor /> -->
      <GlitchOverlay :enabled="true" :frequency="1.0" :intensity="1.0" blend-mode="screen" />
      <ContactFormPopup />
      <!-- Шапка вынесена из потока: она ужимается при скролле и уезжает вверх при
           прокрутке вниз, в потоке контент бы дёргался. Поэтому верхний воздух под
           шапку даёт layout, а не страницы. Роуты с header_mode: 'overlay' (главная,
           кейсы) отступа не получают — там первый экран намеренно уходит под шапку.
           Класс висит на самой странице, а не на #screen: роут меняется в начале
           анимации ухода, и отступ на контейнере дёргал бы уходящую страницу. -->
      <router-view v-slot="{ Component, route: viewRoute }">
        <Transition name="page" mode="out-in" @after-leave="onAfterLeave">
          <component
            :is="Component"
            :key="viewRoute.fullPath"
            :class="{ 'pd-t-extra': viewRoute.meta.header_mode !== 'overlay' }"
          />
        </Transition>
      </router-view>
      <component v-if="$route.meta.footer" :is="$route.meta.footer" />
    </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'
import { useStore } from '@ozdao/martyrs/modules/core/client'
import GlitchOverlay from '@/components/partials/GlitchOverlay.vue'
import Preloader from '@/components/partials/Preloader.vue'
import CursorLabel from '@/components/partials/CursorLabel.vue'
// import Cursor from '@/components/partials/Cursor.vue'
import ContactFormPopup from '@/components/sections/ContactFormPopup.vue'

// Preload критичных шрифтов - разрывает цепочку CSS → fonts
useHead({
  link: [
    { rel: 'preload', href: '/static/fonts/AvenirNextWorld-Regular.woff2', as: 'font', type: 'font/woff2', crossorigin: '' },
    { rel: 'preload', href: '/static/fonts/AvenirNextWorld-Medium.woff2', as: 'font', type: 'font/woff2', crossorigin: '' },
    { rel: 'preload', href: '/static/fonts/AvenirNextWorld-Demi.woff2', as: 'font', type: 'font/woff2', crossorigin: '' },
    { rel: 'preload', href: '/static/fonts/AvenirNextWorld-Bold.woff2', as: 'font', type: 'font/woff2', crossorigin: '' },
  ],
  script: [
    { src: 'https://www.googletagmanager.com/gtag/js?id=G-RNKVQQ3XRL', async: true },
    {
      children: `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-RNKVQQ3XRL');`
    }
  ]
})

const store = useStore()
const showPreloader = ref(true)

const route = useRoute()
const headerTheme = computed(() => route.meta?.header_theme || 'light')

const onPreloaderComplete = () => {
  showPreloader.value = false
}

// Вызывается после ухода старой страницы при transition
const onAfterLeave = () => {
  // Просто скроллим scrollview наверх
  const scrollview = document.getElementById('screen');
  if (scrollview) {
    scrollview.scrollTop = 0;
  }
}
</script>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.page-enter-to,
.page-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
